import styled from 'styled-components';
import { ReactComponent as EmptyFolder_ } from 'Images/empty-folder.svg'; // ajustá a tu path real

export const Pill = styled.div`
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;

  color: ${({ theme }) => theme.text?.tableVulnName || '#1c4566'};
  background: ${({ theme }) => theme.backgrounds?.pill || 'rgba(83,169,255,0.12)'};
  border: 1px solid ${({ theme }) => theme.borders?.pill || 'rgba(83,169,255,0.35)'};
`;

export const Icon = styled(EmptyFolder_)`
  width: 14px;
  height: 14px;
  margin-right: 6px;
  flex: 0 0 auto;

  color: ${({ theme }) => theme.text?.tableVulnName || '#1c4566'};

  & path { fill: currentColor !important; }
  & g path { fill: currentColor !important; }

  & * { stroke: currentColor; }
`;
